import Cookies from 'js-cookie'
import { setLoading, setFinished, setInitial } from './LoadingButton'
import { open } from './Modal'

export default () => {
  const forms = document.querySelectorAll('.js-form')

  if (forms) {
    ;[...forms].forEach(form => {
      form.addEventListener('submit', e => {
        e.preventDefault()

        const button = form.querySelector('.c-button')
        const notice = form.querySelector('.c-notice')
        const isModalForm = form.classList.contains('js-modal-form') // Check if this is a modal form

        setLoading(button) // Set button to loading

        if (!form.checkValidity()) return

        sendForm(form)
          .then(handleFetch)
          .then(r => {
            if (r.error) {
              setInitial(button)
              notice.innerHTML = r.error
              return
            }
            setFinished(button)
            sendGTAEvent(form)
            setTimeout(() => {
              if (isModalForm) {
                // Save email adress in a Cookie
                saveEmailAndFillForms(form)
                // Toggle second form
                toggleSecondModal(form)
              } else {
                // Redirect to thank-you page
                window.location = r.action
              }
              setInitial(button)
              resetForm(form)
            }, 1000)
          })
          .catch(e => {
            console.error(e)
            setInitial(button)
            notice.innerHTML =
              'Kan formulier niet versturen. Probeer het a.u.b. opnieuw of neem contact met ons op.'
          })
      })
    })
  }

  const saveEmailAndFillForms = form => {
    const email = form.querySelector('[type="email"]')
    if (email) {
      Cookies.set('email', email.value)
      const forms = document.querySelectorAll('.js-modal-form')
      ;[...forms].forEach(form => {
        const input = form.querySelector('[type="email"]')
        if (input) input.value = email.value
      })
    }
  }

  const toggleSecondModal = form => {
    const id = form.parentNode.parentNode.parentNode.id
    open(`${id}-second`)
  }

  const sendForm = form =>
    window.fetch('/wordpress/wp-admin/admin-ajax.php?action=send_form', {
      method: 'post',
      body: new window.FormData(form)
    })

  function sendGTAEvent(form) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'formSent',
      form:
        form.querySelector("input[name='form_id']") !== undefined &&
        form.querySelector("input[name='form_id']") !== null
          ? form.querySelector("input[name='form_id']").value
          : 'Onbekend',
      product: form.querySelector("input[name='product']") !== undefined &&
      form.querySelector("input[name='product']") !== null
        ? form.querySelector("input[name='product']").value
        : '',
      product_id: form.querySelector("input[name='product_id']") !== undefined &&
      form.querySelector("input[name='product_id']") !== null
        ? form.querySelector("input[name='product_id']").value
        : ''
    })
  }

  const resetForm = form => form.reset()

  const handleFetch = r => {
    if (!r.ok) {
      const error = {
        error:
          'Kan formulier niet versturen. Probeer het a.u.b. opnieuw of neem contact met ons op.'
      }
      return error
    } else {
      return r.json()
    }
  }
}

window.fillForm = () => {
  const forms = document.querySelectorAll('form')
  if (!forms) return
  ;[...forms].forEach(form => {
    const inputs = form.querySelectorAll('.c-input__input')
    ;[...inputs].forEach(input => {
      const { type, required, name } = input
      if (required === true) {
        if (type === 'text') {
          input.value = `BRIGHT TEST ${Math.random().toString(36).substring(7)}`
        } else if (type === 'email') {
          input.value = 'TEST@TEST.COM'
        } else if (type === 'tel') {
          input.value = '06-12345678'
        } else if (name === 'message') {
          input.value = 'Message'
        }
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/SendForm.js